export const translations = {
    HE: {
        // Navbar
        products: 'הערכות',
        bundles: 'באנדלים',
        bundleSoldOut: 'אזל מהמלאי',
        bundleNotFound: 'הבאנדל לא נמצא',
        bundleLoadError: 'אירעה שגיאה בטעינת הבאנדל',
        bundleSectionLabel: 'ערכה',
        viewFullProductPage: 'לדף המוצר המלא',
        colors: 'צבעים',
        bundleSavings: 'חסכון של ₪{amount} ({percent}%)',
        bundleAddToCart: 'הוספה לסל',
        bundleCartUnavailable: 'אזל מהמלאי',
        cartHasUnavailableItems: 'יש פריטים שאינם זמינים בעגלה — הסירו אותם לפני המעבר לתשלום',
        aboutUs: 'מי אנחנו',
        contact: 'יצירת קשר',
        home: 'דף הבית',

        // Footer
        storeName: 'המקדש',
        storeDescription: 'בונים את המסורת בבית',
        followUs: 'עקבו אחרינו',
        allRightsReserved: 'כל הזכויות שמורות',
        privacyPolicy: 'מדיניות פרטיות',
        termsOfService: 'תנאי שימוש',
        siteTerms: 'תקנון האתר',
        returns: 'החזרות',

        // Cookie consent
        cookiePreferences: 'העדפות עוגיות',
        cookieBannerTitle: 'הפרטיות שלכם חשובה לנו',
        cookieBannerText: 'אנו משתמשים בעוגיות כדי להבטיח את פעילות האתר, לשפר את חוויית השימוש ולנתח את ביצועי האתר. תוכלו לבחור אילו עוגיות לאשר או לשנות את ההעדפות שלכם בכל עת.',
        cookieAcceptAll: 'אישור הכל',
        cookieCustomize: 'התאמה אישית',
        cookieRejectAll: 'דחיית הכל',
        cookieSavePreferences: 'שמירת העדפות',
        cookiePreferencesTitle: 'העדפות עוגיות',
        cookiePreferencesIntro: 'בחרו את העדפות העוגיות שלכם. עוגיות חיוניות נדרשות לפעילות התקינה של האתר ותמיד יישארו פעילות.',
        cookieEssentialTitle: 'עוגיות חיוניות',
        cookieEssentialDesc: 'עוגיות אלו נדרשות להפעלה התקינה של האתר ולכן אינן ניתנות לביטול. הן מאפשרות שימוש בפונקציות בסיסיות כגון שמירת עגלת הקניות, תהליך התשלום, העדפת השפה ואבטחת האתר.',
        cookieEssentialAlwaysOn: 'תמיד פעילות',
        cookieAnalyticsTitle: 'עוגיות אנליטיקה',
        cookieAnalyticsDesc: 'עוגיות אלו מסייעות לנו להבין כיצד מבקרים משתמשים באתר, לזהות בעיות ולשפר את הביצועים וחוויית המשתמש. כל המידע נאסף באופן מצטבר ואינו משמש לזיהוי אישי של המשתמש.',
        cookieAdvertisingTitle: 'עוגיות פרסום',
        cookieAdvertisingDesc: 'עוגיות אלו משמשות למדידת המרות ולהערכת ביצועי קמפיינים פרסומיים. כך התוכן הפרסומי מותאם להעדפות שלכם.',
        cookieServicesIncludes: 'כולל:',
        cookieClose: 'סגירה',
        cookiePrivacyLinkPrefix: 'למידע נוסף ראו את ',
        cookiePrivacyLinkSuffix: '.',

        // Home Page
        heroTagline: 'מתנות שמעצבות את הלב',
        deliveryWithin7Days: 'משלוח עד 7 ימי עסקים',
        addToCart: 'הוספה לעגלה',
        loadingProducts: '..תנו לנו שנייה',
        mainTitle: 'הילדים בונים|ובית המקדש מתעורר לחיים!',
        mainDescription: 'ערכות בנייה ייחודיות, המשלבות יצירה, למידה וחיבור למסורת היהודית – חוויה מושלמת לכל המשפחה!',
        secondTitle: 'גלו את מוצר הדגל שלנו',
        secondDescription: 'המקדש השני - המוצר שממנו הכל התחיל.',
        bundlesSectionTitle: 'באנדללללים',
        bundlesSectionSubtitle: 'ארזנו לכם באנדלים של הערכות שלנו במחיר מיוחד!',
        whatOurCustomersSay: 'לקוחות מספרים',
        whatOurCustomersSaySubtitle: 'הלקוחות שלנו - כלומר אתם - כותבים לנו הודעות שבלעדיהן היה קשה יותר לקום בבוקר. תודה על זה :)',

        // Promo slider
        promoSliderRegion: 'מצגת מבצעים',
        promoSliderPrev: 'שקופית קודמת',
        promoSliderNext: 'שקופית הבאה',
        promoSliderPause: 'השהה מצגת',
        promoSliderPlay: 'הפעל מצגת',

        // FAQ
        faqTitle: 'שאלה טובה',
        faqSubtitle: 'אולי נענה לכם כאן על מה שתרצו לדעת :)',
        faqContact: 'בכל שאלה אנא פנו לשירות הלקוחות שלנו🌼',
        faqReplyFast: 'אנחנו עונים מהר :)',
        faqWhatsAppCta: 'לוואטסאפ שלנו',
        faqQ1Question: 'אתם שולחים לכל הארץ? כמה זמן זה לוקח?',
        faqQ1Answer: 'כן! ברוב הפעמים זה עד 5 ימי עסקים, למעט מקרים חריגים בהם זה עד 7 ימי עסקים.',
        faqQ2Question: 'החלקים הם מלגו אמיתי או לא?',
        faqQ2Answer: 'החלקים הם לא מלגו אמיתי, כי לגו לא רוצים לשתף פעולה עם ערכות שקשורות באופן ישיר לדת (כמו בית המקדש), אבל נסענו עד לסין ובדקנו שהאיכות של החלקים לא נופלת משל לגו! החלקים באיכות מעולה.',
        thirdTempleIntroTitle: 'קצת על הערכה',
        thirdTempleIntro: 'בית המקדש השלישי הוא פרויקט **שאפתני**, שמנסה להיות מרהיב יותר, גדול יותר, מיוחד יותר - מבית המקדש השני. זה לא היה קל ליצור דגם כזה, אבל נראה לנו שעמדנו במשימה. מדובר בדגם **מאוד מיוחד** שמצליח להתעלות על כל הדגמים האחרים שלנו. הוא מגיע באריזה מרהיבה, ומורכב **מ2033! חלקים**. הילדים שלכם יוכלו לחוות חוויה סופר **מאתגרת**, מלמדת וערכית, ואפילו קצת **למשש את העתיד** בידיים..',
        faqQ3Question: 'יש דרך להשיג את זה דרך החנויות?',
        faqQ3AnswerBefore: 'זה לא מופץ כרגע לכל החנויות אבל יש מוקדי חלוקה בירושלים ובמרכז - ',
        faqQ3AnswerLink: 'צרו איתנו קשר',
        faqQ3AnswerAfter: ' ונחבר אתכם למוקד החלוקה הרצוי.',
        faqQ4Question: 'לאיזה גילים זה מתאים?',
        faqQ4Answer: 'כדי שילד/ה יבנו את זה לבד, הם צריכים להיות בגיל 9+. בעזרת מבוגר אפשר גם מגילים נמוכים יותר כמו 6-7.',
        faqQ5Question: 'יש מחיר מיוחד לכמויות גדולות?',
        faqQ5AnswerBefore: 'כן בטח! המחיר משתנה לפי הכמות שתבקשו, ונהיה נמוך יותר ככל שהכמות גדלה. המינימום הנדרש הוא 10 יחידות. לפרטים נוספים ',
        faqQ5AnswerLink: 'צרו איתנו קשר בווצאפ',
        faqQ5AnswerAfter: ' ונדבר:)',

        // Newsletter
        newsletter: 'ניוזלטר',
        newsletterGiftTeaser: 'אני רוצה הנחה',
        newsletterGiftTeaserLine1: 'אני רוצה',
        newsletterGiftTeaserLine2: 'הנחה',
        newsletterGiftBannerTitle: 'יש! מצאתם את זה!',
        newsletterGiftBannerBody:
            'הירשמו לניוזלטר השווה שלנו, ותקבלו 5% הנחה על הקנייה הראשונה שלכם!',
        newsletterModalTitle: 'הירשמו לניוזלטר השווה שלנו',
        newsletterSectionTitle: 'הירשמו לניוזלטר השווה',
        newsletterBenefit1: 'רעיונות וחידונים בהקשר של בית המקדש ופרשיות השבוע',
        newsletterBenefit2: 'שליח מיוחד יבוא עד המייל שלכם ויספר לכם על כל המבצעים, ההטבות, והמוצרים החדשים שעתידים להגיע!',
        newsletterNoSpam: 'אתם הכי חשובים לנו, ולכן לעולם לא נשלח ספאם ולא נעשה שימוש לרעה בכתובת האימייל שלכם.',
        newsletterPrivacyPrefix: 'אני מסכים/ה ומקבל/ת את ',
        newsletterPrivacyLinkText: 'מדיניות הפרטיות',
        newsletterPrivacyRequired: 'עוד צעד קטן — אנא אשרו את מדיניות הפרטיות.',
        newsletterEmailPlaceholder: 'כתובת אימייל',
        newsletterSubmit: 'הרשמה',
        newsletterSubscribeSuccessTitle: 'יששש!',
        newsletterSubscribeSuccessBody:
            'כבר מחכה לכם הודעה ראשונה מאיתנו בתיבת הדואר!\nתמצאו שם קוד קופון, יחד עם כפתור לאישור ההרשמה :)',
        newsletterAlreadySubscribed:
            'היייי, אתם כבר איתנו! שמחים שניסיתם להירשם שוב!',
        // Newsletter verification email
        newsletterEmailSubject: 'ברוכים הבאים לניוזלטר השווה של חנות המקדש',
        newsletterEmailHeading: 'ברוכים הבאים לניוזלטר השווה של חנות המקדש',
        newsletterEmailCouponIntro: 'הנה קוד הקופון שלכם להנחה של {percent}% להזמנה הראשונה:',
        newsletterEmailConfirmHint: 'יש לאשר את האימייל כדי שהקוד ייכנס לתוקף.',
        newsletterEmailConfirmButton: 'אישור אימייל',
        newsletterEmailValidityNote: 'הקישור תקף לשבוע אחד. לאחר מכן הוא לא יהיה תקף יותר ❤️',
        newsletterEmailPurchaseButton: 'לרכישה באתר',
        newsletterEmailRequired: 'נא להזין אימייל',
        newsletterEmailTooLong: 'כתובת האימייל ארוכה מדי',
        newsletterSubmitError: 'לא הצלחנו להירשם כרגע. נסו שוב.',
        newsletterVerifyFailed: 'לא ניתן לאשר',
        newsletterVerifyInvalid: 'קישור האישור לא תקין או שפג תוקפו.',
        newsletterBackHome: 'חזרה לדף הבית',
        newsletterUnsubscribeTitle: 'חבל לנו שאת/ה עוזב/ת :(',
        newsletterUnsubscribeBody: 'הזינו את האימייל שלכם להסרה מהניוזלטר.',
        newsletterUnsubscribeSubmit: 'הסרה',
        newsletterFooterUnsubscribe: 'הסרה מרשימת התפוצה',
        newsletterUnsubscribed: 'הוסרתם מרשימת התפוצה.',
        newsletterEmailNotFound: 'האימייל הזה לא רשום לניוזלטר.',
        newsletterUnsubscribeError: 'לא ניתן להשלים את ההסרה. נסו שוב.',
        newsletterTryAgain: 'נסו שוב',
        newsletterFooterCta: 'הרשמה לניוזלטר',

        giftUnlockedMessage: 'מגיע לכם ספר מתנה עם {product}.',
        giftSelectNow: 'בחרו בעגלה',
        giftSelectLater: 'סגור',
        giftGotIt: 'הבנתי',
        giftChooseTitle: 'בחרו ספר מתנה',
        giftSelectedProgress: '{n} מתוך {total} נבחרו',
        giftDeclineGift: 'אני לא רוצה מתנה',
        giftAutoAssigned: 'מתנה כלולה',
        giftFreeIncludedLabel: 'מתנה חינם כלולה ברכישה זו',
        giftFreeChip: 'מתנה',
        giftCartTitle: 'איזה כיף לתת לך מתנה ❤️',
        giftCartBody: 'מגיע לך ברכישה הזו את הספר המבוקש ״גיבורי העם שלנו״!',
        giftCartBodyMulti: 'מגיע לך ברכישה הזו ספר מתנה מסדרת הספרים כאן למטה!',
        giftCartTitleDouble: 'איזה כיף לתת מתנה כפולה!',
        giftCartBodyDouble: 'מגיע לך שני ספרים(!) מסדרת הספרים כאן למטה',
        giftContinueCheckout: 'למילוי הפרטים',
        giftSelectBook: 'בחירה',

        // Product Detail
        gallery: 'גלריה',
        productsThatMayInterestYou: 'הערכות הנוספות שלנו',

        // Cart Page
        continueShopping: 'חזרה לאתר',
        continueToPayment: 'יאללה לתשלום',
        total: 'סך הכל',
        quantity: 'כמות',
        price: 'מחיר',
        shoppingCart: 'עגלת קניות',
        cartPricesUpdated: 'חלק מהמחירים בעגלה עודכנו. אנא בדקו את העגלה לפני המעבר לתשלום.',
        orderSummary: 'סיכום הזמנה',
        couponCode: 'קוד קופון',
        enterCouponCode: 'יש לך קופון?',
        subtotal: 'סכום ביניים',
        discount: 'הנחה',
        cartEmptyMessage: 'כרגע סל הקניות שלך ריק 😢',
        emptyCartAlt: 'העגלה שלך ריקה',
        enterCouponCodeRequired: 'נא להזין קוד קופון',
        couponAppliedPrefix: 'יש! חסכת ₪',
        couponNotFound: 'אממ, נראה שאין קוד קופון כזה :(',
        networkErrorRetry: 'שגיאת רשת. נסו שוב.',
        homeDeliverySelected: 'יש לך משלוח עד הבית!',

        // Customer Info
        customerInfo: 'פרטי לקוח',
        name: 'שם מלא',
        email: 'אימייל',
        phone: 'טלפון',
        city: 'עיר',
        cancel: 'ביטול',
        processing: 'מעבד...',
        cartEmpty: 'העגלה שלך ריקה',
        paymentFailed: 'התשלום נכשל. אנא נסה.י שוב.',
        paymentSuccess: 'תשלום הושלם בהצלחה!',
        thankYouPurchaseTitle: 'תודה שרכשת אצלינו!',
        thankYouPurchaseDescription: 'אנחנו מטפלים בהזמנה שלך ברגעים אלה ועושים מאמץ שהיא תגיע כמה שיותר מהר :)',
        thankYouPurchaseDescription2: '(עד 7 ימי עסקים)',
        paymentFailedMessage: 'מצטערים, התשלום לא הושלם :(',
        paymentFailedMessage2: 'אנא נסה.י שוב או פנה.י אלינו לעזרה.',
        transactionId: 'מספר עסקה:',
        backToWebsite: 'לחזור לאתר',
        tryAgain: 'נסה שוב',

        // Payment
        securePayment: 'תשלום מאובטח',
        securePaymentCardcom: 'תשלום מאובטח דרך CardCom',
        paymentSuccess: 'התשלום בוצע בהצלחה!',
        paymentFailed: 'התשלום נכשל. אנא נסה/י שוב.',
        paymentCancelled: 'התשלום בוטל',
        paymentCancelledMessage: 'התשלום בוטל על ידך. לא נגבה שום סכום.',
        orderId: 'מספר הזמנה',
        invoiceNumber: 'מספר חשבונית',
        invoiceEmailSentGeneric: 'החשבונית נשלחה לכתובת המייל שהזנת בעת התשלום.',
        paymentSuccessNote: 'התשלום שלך עובד בהצלחה. חשבונית נשלחה לכתובת המייל שלך.',

        // Site Feedback (checkout)
        siteFeedbackTitle: 'יש לך רגע לשתף אותנו איך היתה לך החוויה באתר?',
        siteFeedbackPlaceholder: 'נשמח לשמוע מה עבד טוב ומה אפשר לשפר...',
        siteFeedbackThankYou: 'ממש תודה על המשוב! מעריכים!',
        siteFeedbackSubmitAriaLabel: 'שליחת משוב',
        siteFeedbackLimit: 'מקסימום 500 תווים',
        siteFeedbackCountUnit: 'תווים',

        // Checkout page (GreenInvoicePayment)
        completeYourOrder: 'השלמת הזמנה',
        checkoutSubtitle: 'עוד רגע וסיימנו',
        checkoutCustomerSubtitle: 'אנא מלא/י את הפרטים שלך להשלמת ההזמנה',
        personalInformation: 'פרטים אישיים',
        namePlaceholder: 'כאן את שמך המלא',
        emailPlaceholder: 'כאן את כתובת האימייל שלך',
        phonePlaceholder: 'כאן את מספר הטלפון שלך',
        dedicationLabel: 'הקדשה',
        dedicationPlaceholder: 'תקדישו לאהובים שלכם אם תרצו',
        street: 'רחוב',
        streetPlaceholder: 'כאן את שם הרחוב',
        houseNumber: 'מספר בית',
        houseNumberPlaceholder: 'כאן את מספר הבית',
        apartmentNumberPlaceholder: 'כאן את מספר הדירה',
        apartmentNumberOptional: 'מספר דירה (אופציונלי)',
        floorOptional: 'קומה (אופציונלי)',
        floorPlaceholder: 'כאן את מספר הקומה',
        cityPlaceholder: 'כאן את שם העיר',
        whatAboutDelivery: 'מה עם משלוח?',
        youHaveHomeDelivery: '!יש לך משלוח עד הבית',
        addHomeDelivery: 'להוסיף משלוח עד הבית (+₪35)',
        selfCollectionInfo: 'איסוף עצמי יתבצע מרחוב העליה 7 נתיבות',
        freeDeliveryOver350: 'בקנייה מעל 350 ₪ משלוח חינם',
        deliveryTime: 'זמן אספקה עד 7 ימי עסקים',
        fillAddressForDelivery: 'אנא מלא/י את פרטי הכתובת שלך למשלוח',
        homeDelivery: 'משלוח עד הבית',
        free: 'חינם',
        selfPickup: 'איסוף עצמי',
        noCharge: 'ללא עלות',
        totalToPay: 'סה"כ לתשלום',
        payNow: 'לשלם עכשיו',
        securePaymentDescription: 'התשלום שלך מוגן על ידי Green Invoice ו-Cardcom עם הצפנה מתקדמת',
        fieldRequired: 'שדה זה הוא חובה',
        invalidEmail: 'כתובת אימייל לא תקינה',
        invalidPhone: 'מספר טלפון לא תקין',
        nameMinLength: 'שם חייב להכיל לפחות 2 תווים',
        fieldMinLength: 'שדה זה חייב להכיל לפחות 2 תווים',
        houseNumberRequired: 'מספר בית הוא חובה',
        acceptTermsRequired: 'אנא אשר/י את תנאי השימוש כדי להמשיך',
        noPaymentFormReceived: 'לא התקבל טופס תשלום מ-Green Invoice',
        paymentFormCreateFailed: 'יצירת טופס התשלום נכשלה',
        networkError: 'שגיאת רשת',
        cardcomPaymentFormTitle: 'טופס תשלום CardCom',

        failureReason: 'סיבת הכישלון',
        paymentFailureNote: 'התשלום נכשל. אנא בדקו את פרטי כרטיס האשראי ונסו שוב.',
        needHelp: 'צריכים עזרה?',
        contactSupportMessage: 'אם יש לכם שאלות או בעיות, אנא צרו איתנו קשר בטלפון: 053-2405276 או בוואטסאפ.',
        contactSupport: 'צור/צרי איתנו קשר',
        backToCart: 'לחזור לעגלה',
        whyCancel: 'למה התשלום בוטל?',
        cancelReasons: 'התשלום יכול להיות מבוטל מכמה סיבות:',
        cancelReason1: 'ביטלת את התשלום באופן ידני',
        cancelReason2: 'חזרת לדף הקודם לפני השלמת התשלום',
        cancelReason3: 'אירעה שגיאה טכנית במערכת התשלומים',

        // Terms of Service
        termsAgreementPrefix: 'קראתי ואני מאשר/ת את ',
        termsAgreementLinkText: 'תנאי השימוש',
        marketingConsentLabel: 'אני רוצה לשמוע על מבצעים ועדכונים על מוצרים חדשים!',
        cancellationPolicy: 'מדיניות ביטולים',
        cancellationText: 'ניתן לבטל את הרכישה עד 14 יום מרכישת המוצר. בתנאי שהמוצר לא נפתח. דמי ביטול סך 70 ₪. החזרת המוצר לעסק היא באחריות הצרכן.',
        cancellationNote: 'במידה והמוצר נפתח אפילו בניילון הנצמד העוטף את המוצר, לא ניתן לבטל את הרכישה.',
        warrantyTitle: 'אחריות מוצר פגום',
        warrantyText: 'מוצר שחלקים ממנו פגומים – באחריותנו לספק חלקים חדשים ללקוח ללא תוספת תשלום ובמשלוח חינם עד הבית.',
        warrantyNote: 'במידה ואבדו לכם חלקים – נוכל לעזור ולספק לכם חלקים מסויימים ללא תשלום וחלקים מיוחדים בתשלום.',
        shippingTitle: 'אספקה',
        shippingText: 'משלוח באמצעות חברת המשלוחים YDM עד 7 ימי עסקים לבית הלקוח.',
        privacyTitle: 'הגנת פרטיות',
        privacyText: 'אנחנו מתחייבים לא להעביר את פרטי הלקוח לצד ג.',
        contactTitle: 'צור קשר',
        contactText: 'אם יש לך שאלות נספות צור/צרי איתנו קשר:',
        termsEmail: 'gilmanor8@gmail.com',
        termsPhone: '053-2405276',
        storeAddress: 'עליה 7 נתיבות, ישראל',

        // Returns
        returnsTitle: 'מדיניות החזרות',
        returnPeriod: 'עד מתי אפשר להחזיר?',
        returnPeriodText: 'אנחנו מקבלים מוצרים עד 14 יום מהקנייה שלהם.',
        eligibleItems: 'מוצרים שניתן להחזיר',
        nonEligibleItems: 'מוצרים שלא ניתן להחזיר',
        returnProcess: 'תהליך ההחזרה',
        refundTiming: 'מתי מקבלים החזר?',
        refundTimingText: 'ברגע שאישרנו את החזרת המוצר:',
        damagedItems: 'מוצרים תקולים או חסרים',
        shippingCosts: 'עלויות השילוח',
        shippingCostsText: 'עלויות משלוח ההחזרה הן באחריות הלקוח, למעט במקרים של פריטים פגומים או תקולים.',
        contactUs: 'צרו קשר',
        contactUsText: 'לשאלות נוספות בנוגע למה שכתוב כאן, או לתחילת תהליך של החזרת מוצר - צרו קשר בדרכים הבאות:',

        // Product conditions
        notOpened: 'המוצר לא נפתח.',
        wrapperNotOpened: 'גם עטיפת הניילון שעל המוצר לא נפתחה.',
        notDamaged: 'המוצר לא נקרע או קיבל מכה או התעקם או כל חבלה אחרת.',
        openedOrDamaged: 'מוצרים שנפתחו או נקרעו או נחבלו בכל חבלה אחרת.',
        over14Days: 'מוצרים שעברו 14 יום מהקנייה שלהם.',

        // Return process steps
        contactWithin14Days: '1. צור/צרי איתנו קשר תוך 14 יום מהרכישה',
        contactDetails: 'התקשר.י ל: 053-2405276 / 0506515689',
        packageSecurely: '3. תארזו את החבילה בצורה בטוחה',
        packageNote: 'ממש כמו שקיבלתם בהתחלה',
        shipToAddress: '4. שלחו אלינו חזרה לכתובת',

        // Refund info
        refund5to7Days: 'ההחזר יתקבל תוך 5-7 ימי עסקים',
        shippingNotIncluded: 'תשלומי המשלוח לא כלולים בהחזר הכספי',
        refundSameMethod: 'ההחזר יתקבל באותה שיטת התשלום ששילמת איתה',

        // Site Terms (תקנון האתר)
        siteTermsIntro: 'ברוכים הבאים לאתר המקדש. השימוש באתר ורכישת מוצרים באמצעותו כפופים לתנאים המפורטים בתקנון זה. שימוש באתר מהווה הסכמה לתנאים אלו.',
        siteTerms1Title: '1. כללי',
        siteTerms1Text: 'האתר משמש כחנות מקוונת למכירת מוצרים להרכבה וליצירה לילדים ומוצרים נלווים. בעלי האתר רשאים לעדכן את התקנון מעת לעת לפי שיקול דעתם.',
        siteTerms2Title: '2. ביצוע הזמנה',
        siteTerms2Text: 'רכישת מוצרים באתר מתבצעת באמצעות הזמנה מקוונת. הלקוח מתחייב למסור פרטים נכונים ומדויקים בעת ביצוע ההזמנה. ההזמנה תאושר רק לאחר קבלת אישור מחברת הסליקה.',
        siteTerms3Title: '3. מחירים ותשלומים',
        siteTerms3Text: 'המחירים באתר מוצגים בשקלים חדשים וכוללים מע"מ אלא אם צוין אחרת. התשלום באתר מתבצע באמצעי תשלום המופיעים בעמוד התשלום.',
        siteTerms4Title: '4. משלוחים',
        siteTerms4Text: 'המוצרים יסופקו לכתובת שנמסרה בעת ההזמנה. זמן האספקה המשוער יופיע בעמוד המוצר או בעמוד המשלוחים באתר. ייתכנו עיכובים שאינם בשליטת בעלי האתר.',
        siteTerms5Title: '5. החזרות וביטולים',
        siteTerms5Text: 'ניתן לבטל עסקה בהתאם להוראות חוק הגנת הצרכן. בקשה לביטול עסקה תיעשה באמצעות פנייה לבעלי האתר בתוך הזמן הקבוע בחוק. המוצר יוחזר כשהוא חדש ובאריזתו המקורית בלבד.',
        siteTerms6Title: '6. אחריות למוצרים',
        siteTerms6Text: 'האחריות למוצרים חלה בהתאם לחוק ולתנאי היצרן. המוצרים מיועדים לשימוש בהתאם להוראות ההרכבה ולגיל המומלץ.',
        siteTerms7Title: '7. קניין רוחני',
        siteTerms7Text: 'כל התכנים באתר, כולל תמונות, טקסטים, עיצובים וסימנים מסחריים, הם רכוש בעלי האתר ואין לעשות בהם שימוש ללא אישור מראש.',
        siteTerms8Title: '8. הגבלת אחריות',
        siteTerms8Text: 'בעלי האתר לא יהיו אחראים לנזק ישיר או עקיף שייגרם כתוצאה משימוש באתר או במוצרים מעבר לנדרש לפי דין.',
        siteTerms9Title: '9. פרטיות',
        siteTerms9Text: 'השימוש באתר כפוף גם למדיניות הפרטיות של האתר.',
        siteTerms10Title: '10. הצהרת שימוש ואחריות',
        siteTerms10Text: 'המוצרים הנמכרים באתר המקדש מיועדים למשחק, יצירה ולמידה. חלק מהמוצרים כוללים חלקים קטנים ולכן יש להשתמש בהם בהתאם להנחיות הגיל המצוינות בעמוד המוצר.',
        siteTerms10Text2: 'השימוש במוצרים מיועד להתבצע תחת השגחת מבוגר במידת הצורך, במיוחד כאשר מדובר בילדים צעירים.',
        siteTerms10Text3: 'בעלי האתר אינם אחראים לשימוש שאינו בהתאם להוראות הבטיחות או להמלצות הגיל המצוינות.',
        siteTerms11Title: '11. יצירת קשר',
        siteTerms11Contact: 'לשאלות ופניות ניתן ליצור קשר דרך עמוד ״צור קשר״ באתר או בכתובת:',
        siteTermsEmail: 'hamikdash.today@gmail.com',

        // Privacy Policy (מדיניות פרטיות)
        privacyIntro: 'ברוכים הבאים לאתר המקדש. אנו מכבדים את פרטיות המשתמשים באתר ומחויבים לשמור על המידע האישי הנמסר לנו. מדיניות פרטיות זו מסבירה כיצד אנו אוספים, משתמשים ושומרים מידע.',
        privacy1Title: '1. איסוף מידע',
        privacy1Intro: 'בעת השימוש באתר ייתכן שייאסף מידע מסוגים שונים, כגון:',
        privacy1List: ['שם פרטי ושם משפחה', 'כתובת דוא”ל', 'מספר טלפון', 'כתובת למשלוח הזמנות', 'פרטי הזמנה ורכישות באתר'],
        privacy1Outro: 'בנוסף, ייתכן שייאסף מידע טכני כגון כתובת IP, סוג דפדפן, מערכת הפעלה, מידע על אופן השימוש באתר ופעולות שבוצעו במהלך הגלישה.',
        privacy2Title: '2. מטרות השימוש במידע',
        privacy2Intro: 'המידע הנאסף ישמש למטרות הבאות:',
        privacy2List: [
            'עיבוד והשלמת הזמנות',
            'משלוח מוצרים',
            'יצירת קשר עם הלקוח במקרה הצורך',
            'שיפור חוויית המשתמש באתר',
            'ניתוח פעילות ושיפור ביצועי האתר',
            'התאמת תכנים ושיווק למשתמשים (במידה וניתנה הסכמה לכך)',
            'שליחת עדכונים והצעות (במידה והמשתמש נתן הסכמה לכך)'
        ],
        privacy3Title: '3. שמירת מידע ואבטחה',
        privacy3Text: 'האתר נוקט באמצעי אבטחה סבירים על מנת להגן על המידע האישי של המשתמשים מפני גישה בלתי מורשית, שימוש לא מורשה או חשיפה.',
        privacy3Text2: 'למרות מאמצים אלו, אין אפשרות להבטיח אבטחה מוחלטת של מידע המועבר דרך האינטרנט.',
        privacy4Title: '4. מסירת מידע לצד שלישי',
        privacy4Intro: 'האתר לא ימכור או יעביר מידע אישי לצדדים שלישיים, למעט במקרים הבאים:',
        privacy4List: [
            'לצורך השלמת הזמנה (למשל חברות משלוח, שירותי סליקה או ספקי שירות טכניים הנדרשים להפעלת האתר)',
            'כאשר קיימת חובה חוקית למסור את המידע',
            'לצורך הגנה על זכויות האתר או המשתמשים'
        ],
        privacy5Title: '5. שימוש בשירותי צד שלישי',
        privacy5Intro: 'האתר עשוי להשתמש בשירותים של ספקי צד שלישי לצורך תפעול האתר, ניתוח פעילות, שיפור חוויית המשתמש, מדידת ביצועים ופעילות שיווקית.',
        privacy5Text: 'שירותים אלו עשויים לאסוף מידע טכני על השימוש באתר, כגון כתובת IP, מידע על הדפדפן והמכשיר, עמודים שנצפו, פעולות שבוצעו באתר ואירועים הקשורים לשימוש באתר.',
        privacy5ListIntro: 'השירותים שבהם האתר עשוי להשתמש כוללים בין היתר:',
        privacy5List: [
            'Google Analytics 4 (GA4) – שירות ניתוח נתוני שימוש באתר המאפשר להבין כיצד משתמשים מגיעים לאתר וכיצד הם משתמשים בו, לצורך שיפור השירות וחוויית המשתמש.',
            'Google Ads – שירות פרסום המאפשר מדידת ביצועי קמפיינים, מעקב אחר המרות והתאמת פרסומות למשתמשים שביקרו באתר, בהתאם להסכמות שניתנו על ידי המשתמש.',
            'Microsoft Clarity – שירות ניתוח חוויית משתמש המאפשר להבין כיצד משתמשים מקיימים אינטראקציה עם האתר, באמצעות מידע כגון הקלטות אנונימיות של פעילות באתר, מפות חום ונתוני שימוש כלליים.',
            'Google Tag Manager (GTM) – מערכת לניהול תגיות המאפשרת טעינה וניהול של שירותי מדידה וניתוח באתר.'
        ],
        privacy5Outro: 'ספקי צד שלישי אלו עשויים לעבד מידע בהתאם למדיניות הפרטיות שלהם ולתנאי השירות שלהם. השימוש בשירותים אלו מתבצע בהתאם לבחירות המשתמש במסגרת מערכת ניהול העוגיות באתר, כאשר נדרשת הסכמה לכך.',
        privacy6Title: '6. שימוש בעוגיות (Cookies)',
        privacy6Intro: 'האתר עשוי להשתמש בקבצי Cookies לצורך תפעול תקין של האתר, שמירת העדפות משתמש, שיפור חוויית המשתמש, ניתוח סטטיסטי של השימוש באתר ופעילות שיווקית.',
        privacy6ListIntro: 'סוגי העוגיות עשויים לכלול:',
        privacy6List: [
            'עוגיות הכרחיות – הנדרשות להפעלת האתר ולביצוע פעולות בסיסיות כגון תהליך רכישה.',
            'עוגיות אנליטיקה – המשמשות למדידת שימוש באתר ושיפור השירות, כגון Google Analytics ו-Microsoft Clarity.',
            'עוגיות שיווק – המשמשות למדידת פרסום והתאמת תכנים שיווקיים, כגון Google Ads.'
        ],
        privacy6Outro: 'המשתמש יכול לבחור את סוגי העוגיות שיאושרו באמצעות חלון ניהול העוגיות באתר.',
        privacy7Title: '7. פרטיות ילדים',
        privacy7Text: 'המוצרים באתר מיועדים לילדים, אך הרכישות והשימוש באתר מיועדים לביצוע על ידי הורים או מבוגרים בלבד. אין למסור מידע אישי של ילדים ללא הסכמת הורה או אפוטרופוס.',
        privacy8Title: '8. זכות לעיון ולתיקון מידע',
        privacy8Text: 'משתמש רשאי לפנות לבעלי האתר בבקשה לעיין, לעדכן או למחוק את המידע האישי שנשמר אודותיו, בהתאם להוראות החוק.',
        privacy9Title: '9. יצירת קשר',
        privacy9Contact: 'לכל שאלה בנוגע למדיניות פרטיות זו ניתן ליצור קשר דרך עמוד יצירת הקשר באתר או בכתובת:',
        privacy10Title: '10. עדכון מדיניות',
        privacy10Text: 'בעלי האתר רשאים לעדכן מדיניות זו מעת לעת. הגרסה המעודכנת תפורסם באתר.'
    },

    EN: {
        // Navbar
        home: 'Home',
        products: 'Products',
        bundles: 'Bundles',
        bundleSoldOut: 'Sold out',
        bundleNotFound: 'Bundle not found',
        bundleLoadError: 'Something went wrong loading this bundle',
        bundleSectionLabel: 'Kit',
        viewFullProductPage: 'View full product page',
        colors: 'Colors',
        bundleSavings: 'Save ₪{amount} ({percent}%)',
        bundleAddToCart: 'Add to cart',
        bundleCartUnavailable: 'Sold out',
        cartHasUnavailableItems: 'Your cart has unavailable items — remove them before checkout',
        aboutUs: 'About Us',
        contact: 'Contact',

        // Footer
        storeName: 'Hamikdash Store',
        storeDescription: 'Your trusted source for authentic Jewish religious items and spiritual artifacts.',
        followUs: 'Follow Us',
        allRightsReserved: '© 2024 Hamikdash Store. All rights reserved.',
        privacyPolicy: 'Privacy Policy',
        termsOfService: 'Terms of Service',
        siteTerms: 'Site Terms',
        returns: 'Returns',

        // Cookie consent
        cookiePreferences: 'Cookie Preferences',
        cookieBannerTitle: 'We use cookies',
        cookieBannerText: 'We use essential cookies to run the site, and optional cookies for analytics and advertising. You can accept all or customize your preferences.',
        cookieAcceptAll: 'Accept All',
        cookieCustomize: 'Customize',
        cookieRejectAll: 'Reject All',
        cookieSavePreferences: 'Save Preferences',
        cookiePreferencesTitle: 'Cookie Preferences',
        cookiePreferencesIntro: 'Choose which cookie categories to allow. Essential cookies always stay on.',
        cookieEssentialTitle: 'Essential Cookies',
        cookieEssentialDesc: 'Required for the website to work correctly and cannot be disabled.',
        cookieEssentialExamples: 'Examples: shopping cart, checkout session, language preference, and security.',
        cookieEssentialAlwaysOn: 'Always on',
        cookieAnalyticsTitle: 'Analytics Cookies',
        cookieAnalyticsDesc: 'Help us understand how visitors use the website so we can improve it.',
        cookieAdvertisingTitle: 'Advertising Cookies',
        cookieAdvertisingDesc: 'Used for conversion measurement and advertising.',
        cookieServicesIncludes: 'Includes:',
        cookieClose: 'Close',
        cookiePrivacyLinkPrefix: 'For more details, see our ',
        cookiePrivacyLinkSuffix: '.',

        // Home Page
        heroTagline: 'Gifts that shape the heart',
        deliveryWithin7Days: 'Delivery within 7 business days',
        addToCart: 'Add to Cart',
        loadingProducts: 'Loading products...',
        mainTitle: 'Children build and Judaism comes to life!',
        mainDescription: 'Unique building kits that combine creativity, learning, and connection to Jewish tradition – a perfect experience for the whole family!',
        secondTitle: 'Discover Our Products',
        secondDescription: 'Each product is carefully selected to enrich your Jewish holiday and tradition experience at home',
        bundlesSectionTitle: 'Bundles',
        bundlesSectionSubtitle: 'We\'ve packed popular kits into bundles at a special price!',
        whatOurCustomersSay: 'What Our Customers Say',
        promoSliderRegion: 'Promotions carousel',
        promoSliderPrev: 'Previous slide',
        promoSliderNext: 'Next slide',
        promoSliderPause: 'Pause carousel',
        promoSliderPlay: 'Play carousel',
        whatOurCustomersSaySubtitle: 'Our customers — that is, you — write us messages that brighten our day. Thank you for that :)',

        // FAQ
        faqTitle: 'Good question',
        faqSubtitle: 'Maybe we can answer what you want to know right here :)',
        faqContact: 'For any question, please contact our customer service 🌼',
        faqReplyFast: 'We reply quickly :)',
        faqWhatsAppCta: 'To our WhatsApp',
        faqQ1Question: 'Do you ship nationwide? How long does it take?',
        faqQ1Answer: 'Yes! Delivery is up to 7 business days nationwide.',
        faqQ2Question: 'Are the parts real LEGO?',
        faqQ2Answer: 'The parts are not real LEGO, because LEGO does not partner with kits tied directly to religion (like the Beit Hamikdash). We went all the way to China and checked that the quality is not below LEGO — the parts are excellent quality.',
        thirdTempleIntroTitle: 'About the Kit',
        thirdTempleIntro: 'The Third Temple is an **ambitious** project that aims to be more magnificent, bigger and more special than the Second Temple. Creating a model like this was not easy, but we believe we rose to the challenge. It is a **truly special** model that surpasses all our other models. It comes in a stunning box and is made up of **2,033 pieces!** Your children will enjoy a super **challenging**, educational and meaningful experience, and even get to **touch the future** with their own hands.',
        faqQ3Question: 'Is there a way to get this through stores?',
        faqQ3AnswerBefore: 'It is not currently distributed to all stores, but there are pickup points in Jerusalem and the center — ',
        faqQ3AnswerLink: 'contact us',
        faqQ3AnswerAfter: ' and we will connect you to the right pickup location.',
        faqQ4Question: 'What ages is this suitable for?',
        faqQ4Answer: 'For a child to build it independently, they should be age 9+. With an adult, younger ages like 6–7 work too.',
        faqQ5Question: 'Is there a special price for large quantities?',
        faqQ5AnswerBefore: 'Yes, of course! The price changes based on the quantity you request, and gets lower as the quantity grows. The minimum required is 10 units. For more details, ',
        faqQ5AnswerLink: 'contact us on WhatsApp',
        faqQ5AnswerAfter: ' and we\'ll talk :)',

        // Newsletter
        newsletter: 'Newsletter',
        newsletterGiftTeaser: 'I want a gift',
        newsletterGiftTeaserLine1: 'I want',
        newsletterGiftTeaserLine2: 'gift',
        newsletterGiftBannerTitle: 'Yes! You found it!',
        newsletterGiftBannerBody:
            'Sign up for our great newsletter and get 5% off your first purchase!',
        newsletterModalTitle: 'Stay in the loop',
        newsletterSectionTitle: 'Stay in the loop',
        newsletterBenefit1: 'Short and beautiful ideas for the weekly Torah portion related to the Temple.',
        newsletterBenefit2: 'Be the first to hear about special offers, promotions, and new products.',
        newsletterNoSpam: 'You are the most important to us, so we will never send you spam or misuse your email address.',
        newsletterPrivacyPrefix: 'I agree and accept the ',
        newsletterPrivacyLinkText: 'Privacy Policy',
        newsletterPrivacyRequired: 'Just one more step — please accept the Privacy Policy.',
        newsletterEmailPlaceholder: 'Email address',
        newsletterSubmit: 'Subscribe',
        newsletterSubscribeSuccessTitle: 'Yesssss!',
        newsletterSubscribeSuccessBody:
            "There's already a first message from us waiting for you in your inbox!\nYou'll find a coupon code there, along with a button to confirm your subscription :)",
        newsletterAlreadySubscribed:
            "Heyyyy, you're already with us! So glad you tried to sign up again!",
        // Newsletter verification email
        newsletterEmailSubject: 'Welcome to the awesome Hamikdash Store newsletter',
        newsletterEmailHeading: 'Welcome to the awesome Hamikdash Store newsletter',
        newsletterEmailCouponIntro: 'Here is your {percent}% off coupon code for your first order:',
        newsletterEmailConfirmHint: 'You need to confirm your email for the code to become active.',
        newsletterEmailConfirmButton: 'Confirm Email',
        newsletterEmailValidityNote: 'The link is valid for one week. After that, it will no longer be valid ❤️.',
        newsletterEmailPurchaseButton: 'Purchase on the Website',
        newsletterEmailRequired: 'Please enter an email',
        newsletterEmailTooLong: 'Email address is too long',
        newsletterSubmitError: 'Could not subscribe right now. Please try again.',
        newsletterVerifyFailed: 'Could not confirm',
        newsletterVerifyInvalid: 'This confirmation link is invalid or has expired.',
        newsletterBackHome: 'Back to home',
        newsletterUnsubscribeTitle: 'Sorry to see you go :(',
        newsletterUnsubscribeBody: 'Enter your email to unsubscribe from the newsletter.',
        newsletterUnsubscribeSubmit: 'Unsubscribe',
        newsletterFooterUnsubscribe: 'Unsubscribe from newsletter',
        newsletterUnsubscribed: 'You have been unsubscribed.',
        newsletterEmailNotFound: 'This email is not subscribed to the newsletter.',
        newsletterUnsubscribeError: 'Could not complete unsubscribe. Please try again.',
        newsletterTryAgain: 'Try again',
        newsletterFooterCta: 'Subscribe to newsletter',

        giftUnlockedMessage: "You're entitled to a gift book with {product}.",
        giftSelectNow: 'Choose in cart',
        giftSelectLater: 'Close',
        giftGotIt: 'Got it',
        giftChooseTitle: 'Choose your free gift book',
        giftSelectedProgress: '{n} of {total} selected',
        giftDeclineGift: "I don't want a gift",
        giftAutoAssigned: 'Gift included',
        giftFreeIncludedLabel: 'Free gift included with this purchase',
        giftFreeChip: 'Free gift',
        giftCartTitle: 'What a joy to give you a gift ❤️',
        giftCartBody:
            'With this purchase you get the popular book “Our Nation’s Heroes”!',
        giftCartBodyMulti:
            'With this purchase you get a gift book from the popular Our Nation’s Heroes series!',
        giftCartTitleDouble: 'What a joy to give a double gift!',
        giftCartBodyDouble:
            'You get two books! From the popular Our Nation’s Heroes series',
        giftContinueCheckout: 'Continue to details',
        giftSelectBook: 'Select',

        // Product Detail
        gallery: 'Gallery',
        productsThatMayInterestYou: 'Products that may interest you',

        // Cart Page
        shoppingCart: 'Shopping Cart',
        cartPricesUpdated: 'Some prices in your cart were updated. Please review your cart before checkout.',
        continueShopping: 'Continue Shopping',
        continueToPayment: 'Continue to Payment',
        total: 'Total',
        quantity: 'Quantity',
        price: 'Price',
        orderSummary: 'Order Summary',
        couponCode: 'Coupon Code',
        enterCouponCode: 'Enter coupon code',
        subtotal: 'Subtotal',
        discount: 'Discount',
        cartEmptyMessage: 'Looks like you haven\'t added any items yet',
        emptyCartAlt: 'Empty cart',
        enterCouponCodeRequired: 'Please enter a coupon code',
        couponAppliedPrefix: 'Yes! You saved ₪',
        couponNotFound: 'Coupon not found or inactive',
        networkErrorRetry: 'Network error. Please try again.',
        homeDeliverySelected: 'Home Delivery Selected',

        // Customer Info
        customerInfo: 'Customer Information',
        name: 'Full Name',
        email: 'Email',
        phone: 'Phone',
        city: 'City',
        cancel: 'Cancel',
        processing: 'Processing...',
        cartEmpty: 'Your cart is empty',
        paymentFailed: 'Payment failed. Please try again.',
        paymentSuccess: 'Payment Completed Successfully!',
        paymentFailedMessage: 'Sorry, the payment was not completed. Please try again or contact us for assistance.',
        transactionId: 'Transaction ID:',
        tryAgain: 'Try Again',

        // Payment
        securePayment: 'Secure Payment',
        securePaymentCardcom: 'Secure payment through CardCom',
        paymentSuccess: 'Payment completed successfully!',
        paymentFailed: 'Payment failed. Please try again.',
        paymentCancelled: 'Payment Cancelled',
        paymentCancelledMessage: 'The payment was cancelled by you. No amount was charged.',
        orderId: 'Order ID',
        invoiceNumber: 'Invoice Number',
        invoiceEmailSentGeneric: 'The invoice was sent to the email address you used at checkout.',
        paymentSuccessNote: 'Your payment was processed successfully. An invoice has been sent to your email.',

        // Site Feedback (checkout)
        siteFeedbackTitle: 'How was your experience on the site?',
        siteFeedbackPlaceholder: 'Tell us what worked well and what we can improve...',
        siteFeedbackThankYou: 'Thank you very much for sharing your feedback with us.',
        siteFeedbackSubmitAriaLabel: 'Submit feedback',
        siteFeedbackLimit: 'Max 500 characters',
        siteFeedbackCountUnit: 'characters',

        // Checkout page (GreenInvoicePayment)
        completeYourOrder: 'Complete Your Order',
        checkoutSubtitle: 'One more step to complete your purchase',
        checkoutCustomerSubtitle: 'Please fill in your details to complete your order',
        personalInformation: 'Personal Information',
        namePlaceholder: 'Enter your full name',
        emailPlaceholder: 'Enter your email address',
        phonePlaceholder: 'Enter your phone number',
        dedicationLabel: 'Dedication (Optional)',
        dedicationPlaceholder: 'Enter dedication (optional)',
        street: 'Street',
        streetPlaceholder: 'Enter street name',
        houseNumber: 'House Number',
        houseNumberPlaceholder: 'Enter house number',
        apartmentNumberPlaceholder: 'Enter apartment number',
        apartmentNumberOptional: 'Apartment Number (Optional)',
        floorOptional: 'Floor (Optional)',
        floorPlaceholder: 'Enter floor number',
        cityPlaceholder: 'Enter city name',
        whatAboutDelivery: 'What about delivery?',
        youHaveHomeDelivery: 'You have home delivery!',
        addHomeDelivery: 'Add Home Delivery (+₪35)',
        selfCollectionInfo: 'Self-collection will be conducted on Aliya Street 7, Netivot',
        freeDeliveryOver350: 'Free delivery for purchases over ₪350',
        deliveryTime: 'Delivery time up to 7 business days',
        fillAddressForDelivery: 'Please fill in your address details for delivery',
        homeDelivery: 'Home Delivery',
        free: 'Free',
        selfPickup: 'Self Pickup',
        noCharge: 'No charge',
        totalToPay: 'Total to Pay',
        payNow: 'Pay Now',
        securePaymentDescription: 'Your payment is protected by Green Invoice and Cardcom with advanced encryption',
        fieldRequired: 'This field is required',
        invalidEmail: 'Invalid email address',
        invalidPhone: 'Invalid phone number',
        nameMinLength: 'Name must be at least 2 characters',
        fieldMinLength: 'This field must be at least 2 characters',
        houseNumberRequired: 'House number is required',
        acceptTermsRequired: 'Please accept the terms and conditions to continue',
        noPaymentFormReceived: 'No payment form received from GreenInvoice',
        paymentFormCreateFailed: 'Failed to create payment form',
        networkError: 'Network error',
        cardcomPaymentFormTitle: 'CardCom Payment Form',

        failureReason: 'Failure Reason',
        paymentFailureNote: 'Payment failed. Please check your credit card details and try again.',
        needHelp: 'Need Help?',
        contactSupportMessage: 'If you have questions or issues, please contact our support team.',
        contactSupport: 'Contact Support',
        backToCart: 'Back to Cart',
        whyCancel: 'Why was the payment cancelled?',
        cancelReasons: 'Payment can be cancelled for several reasons:',
        cancelReason1: 'You manually cancelled the payment',
        cancelReason2: 'You went back to the previous page before completing payment',
        cancelReason3: 'A technical error occurred in the payment system',

        // Terms of Service
        termsAgreementPrefix: 'I have read and agree to ',
        termsAgreementLinkText: 'terms and conditions',
        marketingConsentLabel: 'I want to hear about promotions and updates on new products',
        cancellationPolicy: 'Cancellation Policy',
        cancellationText: 'You may cancel your purchase within 14 days of purchasing the product, provided the product has not been opened. A cancellation fee of ₪70 applies. Returning the product to the store is the responsibility of the customer.',
        cancellationNote: 'If the product has been opened, even if only the shrink wrap was removed, the purchase cannot be canceled.',
        warrantyTitle: 'Damaged Product Warranty',
        warrantyText: 'If any part of the product is defective, we are responsible for providing replacement parts to the customer free of charge, with free home delivery.',
        warrantyNote: 'If parts are lost, we can provide certain parts free of charge, while special parts may require payment.',
        shippingTitle: 'Shipping',
        shippingText: 'Delivery is via YDM shipping company within 7 business days to the customer\'s address.',
        privacyTitle: 'Privacy Protection',
        privacyText: 'We are committed not to share customer information with any third party.',
        contactTitle: 'Contact Us',
        contactText: 'If you have any questions, please contact us:',
        termsEmail: 'gilmanor8@gmail.com',
        termsPhone: '+972-53-2405276',
        storeAddress: '7 Aliya Street, Netivot, Israel',

        // Returns
        returnsTitle: 'Returns and Refund Policy',
        returnPeriod: 'Return Period',
        returnPeriodText: 'We accept returned products within 14 days of purchase.',
        eligibleItems: 'Items that can be returned',
        nonEligibleItems: 'Items that cannot be returned',
        returnProcess: 'Return Process',
        refundTiming: 'Refund Timing',
        refundTimingText: 'Once we have approved the return:',
        damagedItems: 'Damaged or Missing Items',
        damagedItemsText: 'If any part of a product is defective, we are responsible for providing replacement parts free of charge, with free home delivery.',
        shippingCosts: 'Shipping Costs',
        shippingCostsText: 'Return shipping costs are the responsibility of the customer, except in cases of damaged or defective items.',
        contactUsText: 'For any questions regarding this policy, or to initiate a return process, please contact us:',

        // Product conditions
        notOpened: 'The product has not been opened.',
        wrapperNotOpened: 'The shrink wrap on the product has not been removed.',
        notDamaged: 'The product is not torn, dented, bent, or otherwise damaged.',
        openedOrDamaged: 'Products that have been opened, torn, or damaged in any way.',
        over14Days: 'Products purchased more than 14 days ago.',

        // Return process steps
        contactWithin14Days: '1. Contact us within 14 days of purchase:',
        contactDetails: 'Call: +972-53-2405276 / +972-50-6515689',
        packageSecurely: '2. Pack the product securely, just like it was received.',
        shipToAddress: '3. Send it back to:',

        // Refund info
        refund5to7Days: 'Refunds are processed within 5–7 business days.',
        shippingNotIncluded: 'Shipping costs are not included in the refund.',
        refundSameMethod: 'The refund will be issued using the same payment method used for the purchase.',

        // Site Terms (תקנון האתר) - English
        siteTermsPageTitle: 'Site Terms / Terms of Use',
        siteTermsIntro: 'Welcome to the Hamikdash website. Use of the site and purchase of products through it are subject to the terms set out in this document. Use of the site constitutes acceptance of these terms.',
        siteTerms1Title: '1. General',
        siteTerms1Text: 'The site serves as an online store for the sale of assembly and craft products for children and related products. The site owners may update these terms from time to time at their discretion.',
        siteTerms2Title: '2. Placing an order',
        siteTerms2Text: 'Purchases on the site are made through an online order. The customer undertakes to provide correct and accurate details when placing the order. The order will be confirmed only after approval from the payment processor.',
        siteTerms3Title: '3. Prices and payments',
        siteTerms3Text: 'Prices on the site are displayed in Israeli Shekels and include VAT unless otherwise stated. Payment on the site is made using the payment methods shown on the payment page.',
        siteTerms4Title: '4. Shipping',
        siteTerms4Text: 'Products will be delivered to the address provided when placing the order. Estimated delivery time will appear on the product page or the shipping page of the site. Delays beyond the site owners\' control may occur.',
        siteTerms5Title: '5. Returns and cancellations',
        siteTerms5Text: 'A transaction may be cancelled in accordance with the Consumer Protection Law. A request to cancel a transaction must be made by contacting the site owners within the period prescribed by law. The product may be returned only when new and in its original packaging.',
        siteTerms6Title: '6. Product warranty',
        siteTerms6Text: 'Product warranty is as required by law and by the manufacturer\'s terms. Products are intended for use in accordance with the assembly instructions and the recommended age.',
        siteTerms7Title: '7. Intellectual property',
        siteTerms7Text: 'All content on the site, including images, texts, designs and trademarks, is the property of the site owners and may not be used without prior permission.',
        siteTerms8Title: '8. Limitation of liability',
        siteTerms8Text: 'The site owners shall not be liable for any direct or indirect damage arising from use of the site or products beyond what is required by law.',
        siteTerms9Title: '9. Privacy',
        siteTerms9Text: 'Use of the site is also subject to the site\'s privacy policy.',
        siteTerms10Title: '10. Use and responsibility statement',
        siteTerms10Text: 'Products sold on the Hamikdash site are intended for play, creativity and learning. Some products contain small parts and must be used in accordance with the age guidelines indicated on the product page.',
        siteTerms10Text2: 'Use of the products is intended to be under adult supervision when necessary, especially for young children.',
        siteTerms10Text3: 'The site owners are not responsible for use that does not comply with safety instructions or the indicated age recommendations.',
        siteTerms11Title: '11. Contact',
        siteTerms11Contact: 'For questions and inquiries, please contact via the Contact page on the site or via the email:',
        siteTermsEmail: 'hamikdash.today@gmail.com',

        // Privacy Policy - English
        privacyIntro: 'Welcome to the Hamikdash website. We respect the privacy of users of the site and are committed to protecting the personal information you provide to us. This privacy policy explains how we collect, use and store information.',
        privacy1Title: '1. Collection of information',
        privacy1Intro: 'When using the site, various types of information may be collected, such as:',
        privacy1List: ['First and last name', 'Email address', 'Phone number', 'Delivery address for orders', 'Order and purchase details on the site'],
        privacy1Outro: 'In addition, technical information such as IP address, browser type, operating system, information on how the site is used, and actions taken while browsing may be collected.',
        privacy2Title: '2. Purposes of use of information',
        privacy2Intro: 'The information collected will be used for the following purposes:',
        privacy2List: [
            'Processing and completing orders',
            'Delivery of products',
            'Contacting the customer when necessary',
            'Improving the user experience on the site',
            'Analyzing activity and improving site performance',
            'Personalizing content and marketing to users (where consent has been given)',
            'Sending updates and offers (if the user has given consent)'
        ],
        privacy3Title: '3. Storage and security of information',
        privacy3Text: 'The site employs reasonable security measures to protect users\' personal information from unauthorized access, use or disclosure.',
        privacy3Text2: 'Despite these efforts, it is not possible to guarantee absolute security of information transmitted over the internet.',
        privacy4Title: '4. Disclosure of information to third parties',
        privacy4Intro: 'The site will not sell or transfer personal information to third parties, except in the following cases:',
        privacy4List: [
            'To complete an order (e.g. shipping companies, payment services, or technical service providers required to operate the site)',
            'When there is a legal obligation to disclose the information',
            'To protect the rights of the site or its users'
        ],
        privacy5Title: '5. Use of third-party services',
        privacy5Intro: 'The site may use third-party providers for site operation, activity analysis, improving user experience, performance measurement, and marketing activity.',
        privacy5Text: 'These services may collect technical information about site usage, such as IP address, browser and device information, pages viewed, actions taken on the site, and events related to site use.',
        privacy5ListIntro: 'The services the site may use include, among others:',
        privacy5List: [
            'Google Analytics 4 (GA4) – a site usage analytics service that helps us understand how users arrive at the site and how they use it, in order to improve the service and user experience.',
            'Google Ads – an advertising service that enables campaign performance measurement, conversion tracking, and ad personalization for users who visited the site, subject to the consents given by the user.',
            'Microsoft Clarity – a user-experience analytics service that helps us understand how users interact with the site, using information such as anonymized session recordings, heatmaps, and general usage data.',
            'Google Tag Manager (GTM) – a tag management system that enables loading and managing measurement and analytics services on the site.'
        ],
        privacy5Outro: 'These third-party providers may process information in accordance with their own privacy policies and terms of service. Use of these services is subject to the user\'s choices in the site\'s cookie management system, where consent is required.',
        privacy6Title: '6. Use of cookies',
        privacy6Intro: 'The site may use cookies for proper operation of the site, storing user preferences, improving user experience, statistical analysis of site usage, and marketing activity.',
        privacy6ListIntro: 'Cookie types may include:',
        privacy6List: [
            'Essential cookies – required to operate the site and perform basic actions such as the purchase process.',
            'Analytics cookies – used to measure site usage and improve the service, such as Google Analytics and Microsoft Clarity.',
            'Marketing cookies – used to measure advertising and personalize marketing content, such as Google Ads.'
        ],
        privacy6Outro: 'The user can choose which cookie types to allow through the cookie management window on the site.',
        privacy7Title: '7. Children\'s privacy',
        privacy7Text: 'The products on the site are intended for children, but purchases and use of the site are intended to be made by parents or adults only. Do not provide children\'s personal information without the consent of a parent or guardian.',
        privacy8Title: '8. Right to access and correct information',
        privacy8Text: 'A user may contact the site owners to request to view, update or delete the personal information stored about them, in accordance with the law.',
        privacy9Title: '9. Contact',
        privacy9Contact: 'For any questions regarding this privacy policy, please contact via the contact page on the site or at:',
        privacy10Title: '10. Policy updates',
        privacy10Text: 'The site owners may update this policy from time to time. The updated version will be published on the site.'
    }
};
